<template>
  <div style="position:relative;height: 700px">
    <!--  这个div里面开始写  -->

    <!--    左侧图片-->
    <div class="left-menu">
      <el-row>
        <el-col :span="24">
          <div class="left-menu-head">
            <img v-if="!leftMenu.head.flag" :id="leftMenu.head.id" @click="getHidden" :width="120" :height="120"
                 :src="leftMenu.head.currentImage"/>
            <ul v-if="leftMenu.head.flag">
              <li v-for="item of leftMenu.user" :key="item.id"><img @click="switchUser(item)" :title="item.adminName"
                                                                    :width="leftMenu.head.size"
                                                                    :height="leftMenu.head.size"
                                                                    :src="item.headPortraitUrl"/></li>
            </ul>
          </div>
        </el-col>
      </el-row>

      <!--      左侧导航信息-->
      <el-row>
        <el-col>
          <div class="wrap">
            <span class="wrap-info" v-for="info of leftMenu.wrapContent" :key="info.id" @click="wrapJump(info)">
              <i :class="info.icon" style="margin-right: 5px"></i>
              {{ info.name }}
            </span>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="right-menu">
      <div v-if="leftMenu.head.id===rightMenu.currentId">
        <!--        111-->
        <h2 class="title" v-if="leftMenu.head.id===rightMenu.currentId"><i :class=rightMenu.icon></i>
          {{ rightMenu.currentTitle }}</h2>
        <div class="mseeageinfo" v-if="rightMenu.currentTitleId===1">
          <div class="userInfo">
            <p><i class="iconfont icon-xingming font-size-18"
                  style="margin-right: 5px"></i>姓名：{{ rightMenu.currentUserInfo.adminName }}</p>
            <p><i class="iconfont icon-xingbie font-size-18"
                  style="margin-right: 5px"></i>性别：{{
                rightMenu.currentUserInfo.sex === undefined ? "" : rightMenu.currentUserInfo.sex === 1 ? '男' : '女'
              }}</p>
            <p><i class="iconfont icon-ziyuan48 font-size-18"
                  style="margin-right: 5px"></i>年龄：{{ rightMenu.currentUserInfo.age }}</p>
            <p><i class="iconfont icon-xueli font-size-18"
                  style="margin-right: 5px"></i>学历：{{ rightMenu.currentUserInfo.education }}</p>
            <p><i class="iconfont icon-qq font-size-18"
                  style="margin-right: 5px"></i>QQ：{{ rightMenu.currentUserInfo.qq }}</p>
            <p><i class="iconfont icon-wodebaobeiye_shengao font-size-18"
                  style="margin-right: 5px"></i>身高：{{ rightMenu.currentUserInfo.height + "cm" }}</p>
            <p><i class="iconfont icon-tizhong font-size-18"
                  style="margin-right: 5px"></i>体重：{{ rightMenu.currentUserInfo.weight + "kg" }}</p>
            <p><i class="iconfont icon-xiexing font-size-18"
                  style="margin-right: 5px"></i>血型：{{ rightMenu.currentUserInfo.blood }}</p>
          </div>

          <div class="rightUserInfo">
            <p><i class="iconfont icon-chushengriqi font-size-18"
                  style="margin-right: 5px"></i>出生日期：{{ rightMenu.currentUserInfo.birthday }}</p>
            <p><i class="iconfont icon-xuexiao1 font-size-18"
                  style="margin-right: 5px"></i>学校：{{ rightMenu.currentUserInfo.school }}</p>
            <p><i class="iconfont icon-zhuanyequanwei font-size-18"
                  style="margin-right: 5px"></i>专业：{{ rightMenu.currentUserInfo.vocational }}</p>
            <p><i class="iconfont icon-yingyu font-size-18"
                  style="margin-right: 5px"></i>英语水平：{{ rightMenu.currentUserInfo.englishLevel }}</p>
            <p><i class="iconfont icon-github-fill font-size-18" style="margin-right: 5px"></i>GitHub：<a
              :href="rightMenu.currentUserInfo.githubUrl" target="_blank">{{ rightMenu.currentUserInfo.githubUrl }}</a>
            </p>
            <p><i class="iconfont icon-mayun font-size-25" style="margin-right: 5px"></i>码云仓库：<a
              :href="rightMenu.currentUserInfo.giteeFactoryUrl"
              target="_blank">{{ rightMenu.currentUserInfo.giteeFactoryUrl }}</a></p>
            <p><i class="iconfont icon-csdn1 font-size-18" style="margin-right: 5px"></i>CSDN博客：<a
              :href="rightMenu.currentUserInfo.csdnUrl" target="_blank">{{ rightMenu.currentUserInfo.csdnUrl }}</a></p>
            <p><i class="iconfont icon-youxiang font-size-18"
                  style="margin-right: 5px"></i>邮箱：{{ rightMenu.currentUserInfo.email }}</p>
          </div>

        </div>

        <div v-if="rightMenu.currentTitleId===2" class="card_wrap">
          <!--          222-->
          <el-row :gutter="40" class="row scrollable">
            <el-col :sm="8" :xs="24" class="center-fixed" v-for="skill in rightMenu.userSkill" :key="skill.id">
              <div class="skills-icon">
                <img :src="skill.skillPic" class="skill_img">
              </div>
              <div class="skills-title">
                <h3>{{ skill.title }}</h3>
                <p>{{ skill.content }}</p>
              </div>
            </el-col>
          </el-row>

        </div>

        <!--          333-->
        <div v-if="rightMenu.currentTitleId===3">
          <el-carousel :interval="4000" style="margin-bottom: 20px" type="card" height="350px">
            <el-carousel-item v-for="hobby in rightMenu.userHobby" :key=hobby.id class="hobby">

              <img style="width: 100%; max-height: 200px;" :src="hobby.picUrl">
              <h3 class="tit">{{ hobby.name }}</h3>
              <p class="tit2">{{ hobby.content }}</p>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--        444-->
        <div v-if="rightMenu.currentTitleId===4">
          <div class="row">
            <ul>
              <li v-for="assess in rightMenu.userAssess" :key="assess.id">
                {{ assess.assess }}
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import request from "../utils/axiosUtils";
import base_url from "../utils/Constants";

export default {
  name: "AboutMe",
  data() {
    return {
      rightMenu: {
        useShow: [
          {
            id: 1,
            name: "个人资料",

          },
          {
            id: 2,
            name: "掌握的技能",
          },
          {
            id: 3,
            name: "我的爱好",
          },
          {
            id: 4,
            name: "自我评价",
          },
        ],
        currentUserInfo: {},

        icon: "iconfont icon-gerenziliao font-size-30",
        currentId: 1,
        currentTitle: "个人资料",
        currentTitleId: 1,
        userSkill: [
          {
            id: null,
            skillPic: null,
            title: null,
            content: null,
            skillId: null,
          }
        ],
        userAssess: [
          {
            id: null,
            assess: null,
            adminId: null,
          }
        ],
        userHobby: [
          {
            id: null,
            picUrl: null,
            name: null,
            content: null,
            adminIdl: null,
            // assess: null,
          }
        ],
      },

      leftMenu: {
        head: {
          id: 1,
          flag: false,
          size: 50,
          currentImage: null,
        },
        wrapContent: [
          {
            id: 1,
            name: "资料",
            icon: ' iconfont icon-gerenziliao font-size-20',
            titleIcon: "iconfont icon-gerenziliao font-size-30",
          },
          {
            id: 2,
            name: "技能",
            icon: ' iconfont icon-jinengbiaoqian font-size-20',
            titleIcon: "iconfont icon-jinengbiaoqian font-size-30",
          },
          {
            id: 3,
            name: "爱好",
            icon: 'iconfont icon-xingquaihao font-size-20',
            titleIcon: "iconfont icon-xingquaihao font-size-30",
          },
          {
            id: 4,
            name: "评价",
            icon: 'iconfont icon-zuopin font-size-20',
            titleIcon: "iconfont icon-zuopin font-size-30",
          },
        ],
        user: [
          {
            id: null,
            adminName: null,
            headPortraitUrl: null,
          }
        ]
      },

    }
  },
  methods: {
    getHidden() {
      // this.leftMenu.head.flag = true;
    },
    wrapJump(info) {
      this.rightMenu.currentTitleId = info.id;

      switch (info.id) {
        case 1:
          this.rightMenu.currentTitle = this.rightMenu.useShow[0].name;
          this.rightMenu.icon = this.leftMenu.wrapContent[0].titleIcon;
          break;
        case 2:
          this.rightMenu.currentTitle = this.rightMenu.useShow[1].name;
          this.rightMenu.icon = this.leftMenu.wrapContent[1].titleIcon;
          break;
        case 3:
          this.rightMenu.currentTitle = this.rightMenu.useShow[2].name;
          this.rightMenu.icon = this.leftMenu.wrapContent[2].titleIcon;
          break;
        case 4:
          this.rightMenu.currentTitle = this.rightMenu.useShow[3].name;
          this.rightMenu.icon = this.leftMenu.wrapContent[3].titleIcon;
          break;
      }
    },

    switchUser(item) {
      this.leftMenu.head.currentImage = item.headPortraitUrl;
      this.leftMenu.head.id = item.id;
      this.leftMenu.head.flag = false;
      switch (item.id) {
        //头像切换时
        case 1:
          this.rightMenu.currentUserInfo = this.leftMenu.user[0]
          this.rightMenu.currentId = 1
          this.resqueHobbyID();
          this.resquestAssessId();
          break;
        case 2:
          this.rightMenu.currentUserInfo = this.leftMenu.user[1];
          this.rightMenu.currentId = 2
          this.resqueHobbyID()
          this.resquestAssessId();
          break;
        case 3:
          this.rightMenu.currentUserInfo = this.leftMenu.user[2];
          this.rightMenu.currentId = 3
          this.resqueHobbyID()
          this.resquestAssessId();
          break;
        case 4:
          this.rightMenu.currentUserInfo = this.leftMenu.user[3];
          this.rightMenu.currentId = 4
          this.resqueHobbyID()
          this.resquestAssessId();
          break;
      }
    },
    resqueHobbyID() {
      this.resquestSkillValue()
      let that = this;
      request({
        url: '/admin/getAdminHobby',
        method: 'get',
        params: {
          id: that.rightMenu.currentId,
        }
      }).then(response => {
        if (response.data.data == null) {
          that.rightMenu.userHobby = [];
        } else {
          response.data.data.forEach(hobby => {
            that.rightMenu.userHobby.id = parseInt(hobby.id);
            hobby.picUrl = base_url + '/getImage/' + hobby.picUrl
          })
          that.rightMenu.userHobby = response.data.data;
        }

      });
    },
    //评价信息
    resquestAssessId() {
      let that = this;
      request({
        url: '/admin/getAdminAssess',
        method: 'get',
        params: {
          id: that.rightMenu.currentId,
        }
      }).then(response => {
        var data = response.data.data;
        if (data === null) {
          that.rightMenu.userAssess = []
        } else {
          that.rightMenu.userAssess = response.data.data;

        }

      })
    },
    //技能信息
    resquestSkillValue() {
      let that = this;
      request({
        url: '/admin/getAdminSkill',
        method: 'get',
        params: {
          value: that.rightMenu.currentId,
        }
      }).then(response => {
        var data = response.data.data;
        if (data === null) {

        } else {
          data.forEach(skill => {
            skill.skillPic = base_url + '/getImage/' + skill.skillPic;
          })
        }
        that.rightMenu.userSkill = response.data.data;

      })
    },
    dateFormat(date) {
      let year = date.getFullYear().toString();
      let month = (date.getMonth() + 1).toString();
      let day = date.getDate().toString();
      return year + "-" + month + "-" + day;
    }
  },
  mounted() {
    this.rightMenu.currentId = this.leftMenu.head.id;
    let that = this;
    request({
      url: '/admin/getAdminUser',
      method: 'get'
    }).then(response => {
      this.leftMenu.head.currentImage = base_url + '/getImage/' + response.data.data[0].headPortraitUrl
      response.data.data.forEach(value => {
        value.id = parseInt(value.id + "".replace("\"", ""))
        value.birthday = that.dateFormat(new Date(value.birthday));
        value.headPortraitUrl = base_url + '/getImage/' + value.headPortraitUrl
      })
      that.leftMenu.user = response.data.data;
      this.rightMenu.currentUserInfo = this.leftMenu.user[0]
      this.leftMenu.head.currentImage = response.data.data[0].headPortraitUrl

    })
    that.resqueHobbyID()
    that.resquestSkillValue()
    this.resquestAssessId();
  },
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}

.left-menu {
  height: 700px;
  width: 240px;
  background: rgba(28, 28, 42, 0.3);
  position: relative;

}

.left-menu-head {
  /*background: #409EFF;*/
  position: relative;
  float: left;
  top: 35px;
  left: 25%;
  width: max-content;
  height: 200px;
  display: inline-block;
  cursor: pointer;
}

.left-menu-head ul {
  display: block;
  width: 100px;
  height: 100px;
}

.left-menu-head li {
  width: 100px;
  /*height: 100px;*/
  position: absolute;
  line-height: 80px;
  text-align: center;
  list-style: none;
  left: 33px;
  top: -8px;
  float: left;
}

.left-menu-head img {
  cursor: pointer;
  border-radius: 50%;
  border: 3px solid white;
}

.left-menu-head li:nth-of-type(1) {
  transform: translate(12px, 7px);
  /*transform-origin:40px 70px;*/
}

.left-menu-head li:nth-of-type(2) {
  transform: translate(-58px, 7px);
  transform-origin: 25px 70px;
}

.left-menu-head li:nth-of-type(3) {
  transform: translate(12px, 79px);
  transform-origin: 25px 70px;
}

.left-menu-head li:nth-of-type(4) {
  /*transform: rotate(0deg);*/
  transform: translate(-58px, 79px);
  transform-origin: 0px 70px;
}

.wrap {
  /*position: absolute;*/
  width: 100%;
}

.wrap-info {
  display: block;
  font-family: 微软雅黑;
  font-size: 20px;
  width: 100%;
  text-align: center;
  line-height: 65px;
  color: rgb(234, 234, 234);
  cursor: pointer;
}

.wrap-info:hover {
  background-color: rgb(60, 60, 60);
}

.right-menu {
  padding-right: 20px;
  position: absolute;
  top: 40px;
  left: 285px;
  width: 900px;
  border: 3px dashed rgb(178, 173, 174);
  background-color: rgba(255, 255, 255, 0.75);
  border-radius: 20px;
}

.title {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
  display: block;
  margin: 40px 30px;
}

.userInfo {
  width: 400px;
  float: left;
  position: relative;
  left: 0px;
  top: -20px;

}

.mseeageinfo p {
  width: 800px;
  line-height: 30px;
  display: block;
  margin: 20px 25px;
  font-size: 15px;
}

.rightUserInfo {
  width: 400px;
  float: right;
  position: absolute;
  /*right: 200px;*/
  margin-top: -20px;
  margin-left: 350px;
}

.el-carousel__item {
  position: absolute;
}

.el-carousel__item h2 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  position: absolute;
}

.el-carousel__item:nth-child(2n) {
  background-color: rgb(253, 254, 254);
}

.el-carousel__item:nth-child(2n+1) {
  background-color: rgb(253, 254, 254);
}

.tit {
  display: block;
  margin: 0 auto;
  line-height: 30px;
  text-align: center;
  opacity: 0.75;
  color: #475669;
  font-size: 20px;

}

.tit2 {
  margin: 0;
  padding: 20px;
  font-size: medium;
  line-height: 30px;
}

.hobby {
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: none;
  margin-bottom: 20px;
  border-radius: 20px;
}

.row li {
  width: 80%;
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: rgb(100, 163, 93) dashed;
  border-radius: 24px;
  height: max-content;
  margin-bottom: 20px;
  line-height: 45px;
  text-align: left;
  background-color: rgba(229, 229, 229, .5);
  margin-left: 60px;
  list-style-type: circle;
  font-family: "Book Antiqua";

}

.card_wrap {
  margin-bottom: 20px;
  margin-left: 20px;
}

.center-fixed {
  text-align: center;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.skills-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  background: #fff;
  border-radius: 100%;
  /*box-shadow: 0 5px rgba(0, 0, 0, 0.3);*/
}

.skills-icon img {
  width: 100px;
  height: 100%;
  margin: 0 auto;
  background: #fff;
  border-radius: 100%;
}

.skills-title p {
  margin-top: 20px;
  line-height: 30px;
}

.skills-title h3 {
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/AboutMe.vue